/**
 * Converter utilities for multi-study system
 *
 * Handles conversion between legacy types and new multi-study types
 * to maintain backwards compatibility.
 */

import { StudyConfig } from "../../../types/landingPage";
import { Study } from "../types";

/**
 * Convert a StudyConfig (from landingPageConfigs.ts) to a Study (new format)
 */
export function convertStudyConfigToStudy(studyConfig: StudyConfig): Study {
  return {
    id: studyConfig.studyId,
    name: studyConfig.studyName,
    trialId: studyConfig.trialIdToAutoApply,
    priority: studyConfig.priority,
    eligibleZipCodes: Array.from(studyConfig.eligibleZipCodes), // Convert readonly to regular array
    questions: studyConfig.additionalQuestions || [],
    metadata: {
      disqualifyMessage: studyConfig.disqualifyMessage,
    },
  };
}

/**
 * Convert an array of StudyConfig to an array of Study
 */
export function convertStudyConfigs(studyConfigs: StudyConfig[]): Study[] {
  return studyConfigs.map(convertStudyConfigToStudy);
}
